import { Button } from 'antd';
import { EM_DASH } from '@/constants/common';
import { useMetadata } from '@/features/metadata/hooks';

export type ProjectTitleProps = {
  projectID: string;
  onClick?: () => void;
};

const ProjectTitle = ({ projectID, onClick }: ProjectTitleProps) => {
  const { projectsByID } = useMetadata();

  if (!projectID) return EM_DASH;

  const title = projectsByID[projectID]?.title;

  if (!title)
    return (
      <span aria-errormessage="project not available" aria-invalid="true">
        <span className="font-mono">{projectID}</span> <span className="error-text">(NOT AVAILABLE)</span>
      </span>
    );

  if (!onClick) return title;
  return (
    <Button type="link" className="p-0 h-auto" onClick={onClick}>
      {title}
    </Button>
  );
};

export default ProjectTitle;
